import { getDecryptedCookie, setEncryptedCookie } from "../../utils/cookieUtils";
import { LEFT_PANEL_COOKIE_KEY, LEFT_PANEL_DEFAULT_WIDTH, LEFT_PANEL_MAX_WIDTH, LEFT_PANEL_MIN_WIDTH } from "./constants";

/** The width of the left panel as remembered for the user, or the default when nothing sensible is stored. */
export function readPanelWidth() {
  const saved = Number(getDecryptedCookie(LEFT_PANEL_COOKIE_KEY));
  return Number.isFinite(saved) && saved >= LEFT_PANEL_MIN_WIDTH && saved <= LEFT_PANEL_MAX_WIDTH ? saved : LEFT_PANEL_DEFAULT_WIDTH;
}

export const writePanelWidth = (width) => setEncryptedCookie(LEFT_PANEL_COOKIE_KEY, String(width));
